var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUnmatched(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_60_525)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_60_525)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_60_525)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.1221 36.8369C17.9087 36.8369 15.8287 36.4166 13.8821 35.5761C11.9354 34.7356 10.2421 33.5958 8.80207 32.1569C7.36207 30.7169 6.22234 29.0236 5.38287 27.0769C4.5434 25.1302 4.12314 23.0502 4.12207 20.8369C4.12207 18.6236 4.54234 16.5436 5.38287 14.5969C6.2234 12.6502 7.36314 10.9569 8.80207 9.51691C10.2421 8.07691 11.9354 6.93718 13.8821 6.09771C15.8287 5.25825 17.9087 4.83798 20.1221 4.83691C22.3354 4.83691 24.4154 5.25718 26.3621 6.09771C28.3087 6.93825 30.0021 8.07798 31.4421 9.51691C32.8821 10.9569 34.0223 12.6502 34.8629 14.5969C35.7034 16.5436 36.1231 18.6236 36.1221 20.8369C36.1221 23.0502 35.7018 25.1302 34.8613 27.0769C34.0207 29.0236 32.881 30.7169 31.4421 32.1569C30.0021 33.5969 28.3087 34.7372 26.3621 35.5777C24.4154 36.4182 22.3354 36.838 20.1221 36.8369ZM15.4821 32.7569L17.4021 28.3569C16.2821 27.9569 15.3157 27.3372 14.5029 26.4977C13.6901 25.6582 13.0565 24.678 12.6021 23.5569L8.20207 25.3969C8.8154 27.1036 9.76207 28.5969 11.0421 29.8769C12.3221 31.1569 13.8021 32.1169 15.4821 32.7569ZM12.6021 18.1169C13.0554 16.9969 13.689 16.0172 14.5029 15.1777C15.3167 14.3382 16.2831 13.718 17.4021 13.3169L15.5621 8.91691C13.8554 9.55691 12.3621 10.5169 11.0821 11.7969C9.80207 13.0769 8.84207 14.5702 8.20207 16.2769L12.6021 18.1169ZM20.1221 25.6369C21.4554 25.6369 22.5887 25.1702 23.5221 24.2369C24.4554 23.3036 24.9221 22.1702 24.9221 20.8369C24.9221 19.5036 24.4554 18.3702 23.5221 17.4369C22.5887 16.5036 21.4554 16.0369 20.1221 16.0369C18.7887 16.0369 17.6554 16.5036 16.7221 17.4369C15.7887 18.3702 15.3221 19.5036 15.3221 20.8369C15.3221 22.1702 15.7887 23.3036 16.7221 24.2369C17.6554 25.1702 18.7887 25.6369 20.1221 25.6369ZM24.7621 32.7569C26.4421 32.1169 27.9157 31.1638 29.1829 29.8977C30.4501 28.6316 31.4031 27.158 32.0421 25.4769L27.6421 23.5569C27.2421 24.6769 26.6287 25.6438 25.8021 26.4577C24.9754 27.2716 24.0154 27.9046 22.9221 28.3569L24.7621 32.7569ZM27.6421 18.0369L32.0421 16.1969C31.4021 14.5169 30.449 13.0438 29.1829 11.7777C27.9167 10.5116 26.4431 9.55798 24.7621 8.91691L22.9221 13.3969C24.0154 13.7969 24.9621 14.4038 25.7621 15.2177C26.5621 16.0316 27.1887 16.9713 27.6421 18.0369Z",
    fill: "url(#paint0_linear_60_525)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_60_525",
    x1: 8.15512,
    y1: -14.8867,
    x2: 45.1516,
    y2: -7.32169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0395,
    stopColor: "#240B3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#3D1E59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671382,
    stopColor: "#8319B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9428,
    stopColor: "#BC14FE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_60_525"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0.955078 0.669922)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_60_525"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0.955078 0.669922)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_60_525"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0.955078 0.669922)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnmatched);
export default __webpack_public_path__ + "static/media/unmatched.d2fbd6234924f3203033b9b5833caa12.svg";
export { ForwardRef as ReactComponent };